






















import { Component, Prop, Vue , Watch } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class CheckOn extends Vue {
    @Prop() private userConfigColor! : string;
}
